import {twMerge} from '../../../common/twMerge';
import {BADGE_TYPE_TO_ICON_TYPE_MAP} from '../../atoms/Icon/constants';
import {Icon} from '../../atoms/Icon/Icon';
import {BadgesWithSpaceProps} from './BadgesWithSpaceProps.interface';

export function BadgesWithSpace({
  badgeList,
  className,
  ...props
}: BadgesWithSpaceProps) {
  const badgeArr = badgeList
    ? Array.isArray(badgeList)
      ? badgeList
      : [badgeList]
    : undefined;

  return (
    <div
      className={twMerge('flex shrink-0 items-center', className)}
      {...props}
    >
      {badgeArr && badgeArr.length > 0 && (
        <div className="flex items-center space-x-2pxr">
          {badgeArr.map((badge, idx) => (
            <Icon
              style={{zIndex: badgeArr.length - idx}}
              key={`${badge}_${idx}`}
              type={BADGE_TYPE_TO_ICON_TYPE_MAP[badge]}
              disableActiveEffect
            />
          ))}
        </div>
      )}
    </div>
  );
}
